import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'component-download',
  templateUrl: './download.component.html',
  styleUrls: ['./download.component.scss']
})
export class DownloadComponent {}